import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';

export default function TopicSection() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {topics.map((t) => (
        <Link
          key={t.id}
          to="/category/all"
          className="group relative rounded-lg overflow-hidden h-56 bg-secondary-100"
        >
          <img
            src={t.cover}
            alt={`${t.name} 专题封面`}
            title={`${t.name} - 网红大赛专题`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-transparent"></div>
          <div className="absolute inset-x-0 bottom-0 p-4">
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-semibold mb-2">
              <i className="ri-file-list-3-line text-[10px]"></i>
              {t.count} 篇
            </span>
            <h3 className="font-heading font-bold text-base text-white leading-snug">{t.name}</h3>
            <p className="mt-1 text-xs text-white/75 line-clamp-2">{t.desc}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}